module.exports = __webpack_public_path__ + "img/倒數開始_壓黑.927a5c61.png";